var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64008 1.33398C4.91843 1.33398 5.14407 1.54062 5.14407 1.79552V2.72654C5.59113 2.7186 6.09223 2.7186 6.65605 2.7186H9.34404C9.90784 2.7186 10.409 2.7186 10.856 2.72654V1.79552C10.856 1.54062 11.0816 1.33398 11.36 1.33398C11.6384 1.33398 11.864 1.54062 11.864 1.79552V2.76737C12.8312 2.8383 13.4662 3.01237 13.9327 3.43957C14.3992 3.86676 14.5892 4.44824 14.6667 5.33398V6.00065H1.33337V5.33398C1.41083 4.44824 1.60091 3.86676 2.0674 3.43957C2.5339 3.01237 3.16886 2.8383 4.13608 2.76737V1.79552C4.13608 1.54062 4.36173 1.33398 4.64008 1.33398Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.6667 9.33333V8C14.6667 7.44067 14.6582 6.44351 14.6496 6H1.33723C1.32863 6.44351 1.33709 7.44067 1.33709 8V9.33333C1.33709 11.8475 1.33709 13.1046 2.11791 13.8856C2.89875 14.6667 4.15547 14.6667 6.66893 14.6667H9.33486C11.8483 14.6667 13.105 14.6667 13.8859 13.8856C14.6667 13.1046 14.6667 11.8475 14.6667 9.33333Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10C11.5523 10 12 10.4477 12 11Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconWhite);
export default __webpack_public_path__ + "static/media/calendar-icon-white.b4d74fbf45e88c245ac3923fa016b985.svg";
export { ForwardRef as ReactComponent };